import React, { useState, useEffect } from 'react';
import { connectToDevice, getDevice } from './ble';
import './DeviceConnection.css';

const connectionStates = {
  notConnected: '❌ Not Connected',
  connecting: '🔄 Connecting...',
  connected: '✅ Connected',
  lostConnection: '⚠️ Lost Connection',
  disconnected: '🚫 Disconnected',
};

const DeviceConnection = ({ onConnect, onDisconnect, onConnectionStateChange, ServiceUUID, externalConnectionState }) => {
  const [connectionState, setConnectionState] = useState(connectionStates.notConnected);
  const [deviceName, setDeviceName] = useState('Connect to device');

  // Use external connection state if provided, otherwise use internal state
  const displayConnectionState = externalConnectionState || connectionState;

  useEffect(() => {
    if (typeof onConnectionStateChange === 'function') {
      onConnectionStateChange(displayConnectionState);
    }
  }, [displayConnectionState, onConnectionStateChange]);

  const handleConnect = async () => {
    setConnectionState(connectionStates.connecting);
    try {
      console.log("Connecting to device with service UUID:", ServiceUUID);
      const device = await connectToDevice(ServiceUUID);
      console.log("Device connected:", device);
      setDeviceName(device.name || 'Unknown Device'); // Use device.name or a default
      setConnectionState(connectionStates.connected);
      if (typeof onConnect === 'function') onConnect();
    } catch (error) {
      console.error("Error connecting to device:", error);
      setConnectionState(connectionStates.notConnected);
    }
  };

  const handleDisconnect = async () => {
    const device = getDevice();
    if (device && device.gatt.connected) {
      await device.gatt.disconnect();
      setConnectionState(connectionStates.disconnected);
      if (typeof onDisconnect === 'function') onDisconnect();
    }
  };

  useEffect(() => {
    const device = getDevice();
    const handleDisconnectEvent = () => {
      setConnectionState(connectionStates.lostConnection);
      if (typeof onDisconnect === 'function') onDisconnect();
    };

    if (device) {
      device.addEventListener('gattserverdisconnected', handleDisconnectEvent);
    }

    return () => {
      if (device) {
        device.removeEventListener('gattserverdisconnected', handleDisconnectEvent);
      }
    };
  }, [onDisconnect]);

  return (
    <div className={`device-connection ${displayConnectionState === connectionStates.connected ? 'connected' : 'disconnected'}`}>
      <h2>{deviceName}</h2>
      <div className="connection-status">{displayConnectionState}</div>
      {displayConnectionState === connectionStates.connected ? (
        <button onClick={handleDisconnect}>Disconnect</button>
      ) : (
        <button onClick={handleConnect}>Connect</button>
      )}
    </div>
  );
};

export default DeviceConnection;
